import PropTypes from "prop-types";
import { Button, SettingsCard } from "top-component-library";
import { MAX_LOGO_BYTES } from "../constants";
import { LogoPreviewImage, PreviewCaption } from "../styles";
import ImageUploadField from "./ImageUploadField";

// When the store is connected to a brand parent the logo is controlled upstream,
// so we show read-only branding info plus an optional disconnect action.
// Otherwise the store uploads its own logo.
const StoreLogoOrBrandingCard = ({
  brandParent,
  brandParentLogoUrl,
  canEditBranding,
  logoUrl,
  customerName,
  onUpload,
  onDelete,
  onDisconnect,
}) => {
  if (brandParent) {
    return (
      <SettingsCard title="Chain Branding">
        <div>
          <p>
            <i>
              When connected to another brand, the brand owner determines the store logo and business name shown on
              brand ordering site landing pages. If you disconnect, you will need to upload your own store logo.
            </i>
          </p>
          <p>
            Currently your store logo and restaurant name displayed on branded ordering sites is controlled by{" "}
            {brandParent.name_for_owner}.
          </p>
          <PreviewCaption>Currently Displayed Business Name</PreviewCaption>
          <p>{brandParent.customer_name}</p>
          <PreviewCaption>Currently Displayed Logo</PreviewCaption>
          <PreviewCaption>{brandParentLogoUrl ? "" : "No Logo Uploaded"}</PreviewCaption>
          {brandParentLogoUrl && <LogoPreviewImage src={brandParentLogoUrl} alt="Brand logo" />}
        </div>
        {canEditBranding && (
          <div>
            <Button type="primary" onClick={onDisconnect}>
              Disconnect from {brandParent.name_for_owner} Brand
            </Button>
            <p>
              <i>
                <b>WARNING:</b> Disconnecting your branding from the brand owner may result in duplicate listings of
                business names. Your business name{customerName ? `, ${customerName},` : ""} will be displayed alongside{" "}
                {brandParent.customer_name}.
              </i>
            </p>
          </div>
        )}
      </SettingsCard>
    );
  }

  return (
    <SettingsCard title="Upload Logo">
      <div>
        <p>For food halls, this will be displayed in multi-vendor menus with other stores.</p>
        <ImageUploadField
          recommendation="Recommended ratio is between 1/1 and 2/1 (width/height, e.g. 400px by 200px). Max 300 KB. Changes may take a few minutes to appear."
          accept={["image/*"]}
          maxSize={MAX_LOGO_BYTES}
          previewVariant="logo"
          currentUrl={logoUrl}
          onUpload={(files) => onUpload("storeLogo", files)}
          onDelete={() => onDelete("storeLogo")}
        />
      </div>
    </SettingsCard>
  );
};

StoreLogoOrBrandingCard.propTypes = {
  brandParent: PropTypes.object,
  brandParentLogoUrl: PropTypes.string,
  canEditBranding: PropTypes.bool,
  logoUrl: PropTypes.string,
  customerName: PropTypes.string,
  onUpload: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDisconnect: PropTypes.func.isRequired,
};

export default StoreLogoOrBrandingCard;
